import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tm-captch',
  templateUrl: './tm-captch.component.html',
  styleUrls: ['./tm-captch.component.scss']
})
export class TmCaptchComponent implements OnInit {
  valid_captcha_flag: boolean;
  valid_captcha: any;
  @Input() class;
  @ViewChild('recaptcha', { static: true }) captch_element: ElementRef;
  @Output() validCaptch = new EventEmitter<any>();
  random_id = 'tm-captcha' + Math.floor((Math.random() * 10000) + 1) + Date.now();

  constructor(
    private change_detector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.addRecaptchaScript();
      console.log('hello')
    })

  }
  addRecaptchaScript() {
    window['grecaptchaCallback'] = () => {
      this.renderReCaptch();
    }

    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptch(); return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
  }
  renderReCaptch() {
    try {
      window['grecaptcha'].render(this.random_id, {
        'sitekey': environment.RECAPCHA_KEY,
        'callback': (response) => {
          this.valid_captcha = response;
          this.valid_captcha_flag = true;
          console.log(this.valid_captcha)
          this.validCaptch.emit(true);
          this.change_detector.detectChanges();
        },
        'expired-callback': (response) => {
          this.expiredCallback();
        },
      });
    }
    catch (err) {
      try {
        setTimeout(() => {
          window['grecaptcha'].render(this.random_id, {
            'sitekey': environment.RECAPCHA_KEY,
            'callback': (response) => {
              this.valid_captcha = response;
              this.valid_captcha_flag = true;
              this.validCaptch.emit(true)
              this.change_detector.detectChanges();
            },
            'expired-callback': (response) => {
              this.expiredCallback();
            },
          });
        }, 200)
      }
      catch (err) {
        setTimeout(() => {
          window['grecaptcha'].render(this.random_id || this.captch_element && this.captch_element.nativeElement, {
            'sitekey': environment.RECAPCHA_KEY,
            'callback': (response) => {
              this.valid_captcha = response;
              this.valid_captcha_flag = true;
              this.validCaptch.emit(true)
              this.change_detector.detectChanges();
            },
            'expired-callback': (response) => {
              this.expiredCallback();
            },
          });
        }, 200)
      }
    }

  }
  expiredCallback() {
    this.valid_captcha = "";
    this.valid_captcha_flag = false
    this.validCaptch.emit(false)
    this.change_detector.detectChanges();

  }

}
